/**
 * @desc 执行请求，不返回结果,返回请求id
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(body: defs.bus.RequestDto, options?: any) {
  return updateResponse(
    http(URL + `/bus/executeExchangeReturnRequestApi`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
